import { render } from "./SwitchOffInactive.vue?vue&type=template&id=6b41e125"
import script from "./SwitchOffInactive.vue?vue&type=script&lang=js"
export * from "./SwitchOffInactive.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__